// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"73":"a166941b","242":"7bc8a509","254":"d0a55649","508":"4ac95155","519":"a451b501","645":"0762b07f","668":"a134d618","977":"257532ad","981":"d8066aa2"}[chunkId] + ".js";
};